"use client";

import type { InputProps } from "@app/_components/ui";
import { Input } from "@app/_components/ui";
import type { ChangeEvent } from "react";
import { type Path, useFormContext } from "react-hook-form";

import { cn } from "@/lib/utils";

import type { AddressFormFields } from "./Checkout.types";

export type CheckoutTextInputProps = InputProps & {
  name: Path<AddressFormFields>;
  label: string;
};

export default function CheckoutTextInput({
  className,
  name,
  ...props
}: CheckoutTextInputProps) {
  const {
    register,
    formState: { errors },
  } = useFormContext<AddressFormFields>();

  const error = errors[name];

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    register(name).onChange(event);
  };

  return (
    <>
      <Input
        className={cn("flex flex-col max-md:col-span-2", className)}
        error={error}
        renderError={(error) => (
          <p className="mt-1 text-base text-red-500">{error?.message}</p>
        )}
        {...register(name)}
        {...props}
        onChange={handleChange}
      />
    </>
  );
}
